export const HadeethCard = ({ hadeeth }) => {
  if (!hadeeth) {
    return (
      <div className="testimonial">
        <div className="testimonial-content">
          <p>Loading today's hadeeth...</p>
        </div>
      </div>
    );
  }

  const link = `https://sunnah.com/${hadeeth.Link || ''}`;

  return (
    <div className="testimonial">
      <div className="testimonial-content">
        <a
          className="testimonial-meta"
          href={link}
          target="_blank"
          rel="noreferrer"
        >
          <h1 className="compiled">{hadeeth.Compiled || 'Sahih Muslim'}</h1>
          <h5 className="book">Book: {hadeeth.Book || 'The book of Pilgrimage'}</h5>
          <h5 className="reference">
            Reference: {hadeeth.Ref1 || ''}{hadeeth.Ref2 ? `; ${hadeeth.Ref2}` : ''}{hadeeth.Ref3 ? `; ${hadeeth.Ref3}` : ''}
          </h5>
          <p className="narrated">{hadeeth.Narrated || ''}</p>
          <p className="hadith">"{hadeeth.Hadith || ''}"</p>
        </a>
      </div>
    </div>
  );
};
